@if (service.loading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}